import { SOCKET_EVENTS } from '@/entities/order/socket/events'
import { emit } from '@/shared/socket/socketClient'

export function joinRestaurantRoom(restoId) {
  if (restoId == null || restoId === '') {
    return
  }
  emit(SOCKET_EVENTS.restaurant.JOIN, restoId)
}

export function joinClientOrderRoom(orderId) {
  if (orderId == null || orderId === '') {
    return
  }
  emit(SOCKET_EVENTS.client.JOIN, String(orderId))
}

export function joinCourierRoom(courierId) {
  if (courierId == null || courierId === '') {
    return
  }
  emit(SOCKET_EVENTS.courier.JOIN, String(courierId))
}
